import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const OverviewChart = ({ activeTab }) => {
    const demoData = {
        Overall: [3150, 1992.78, 1827.45, 747.62, 1151.13, 1935.95, 1066.92, 562.13, 2881.45, 2292.45, 2174.65, 678.38],
        Weekly: [500, 450, 480, 520, 530, 490, 510],
        Monthly: [15000, 17000, 16000, 18000, 19000, 18500, 17500, 20000, 21000, 19500, 20500, 19800],
        Yearly: [180000, 190000, 200000, 210000, 220000, 230000, 225000, 235000, 245000, 240000, 250000, 255000]
    };

    const labels = {
        Overall: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        Weekly: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        Monthly: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        Yearly: ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
    };

    const data = {
        labels: labels[activeTab],
        datasets: [
            {
                data: demoData[activeTab],
                backgroundColor: '#10172B',
                borderColor: '#10172B',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: { display: false },
                ticks: {
                    callback: function (value) {
                        return '$' + value;
                    },
                },
            },
            x: { grid: { display: false } },
        },
    };

    return (
        <div className="rounded-xl border bg-card text-card-foreground sales-cards-shadow col-span-1 lg:col-span-4" style={{height:'400px'}}>
            <div className="flex flex-col space-y-1.5 p-3">
                <div className="tracking-tight text-sm font-medium">{activeTab} Overview</div>
            </div>
            <div className="p-3 pt-0 pl-2">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default OverviewChart;